"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryTableHeadSx = void 0;
// Primary-colored table header (matches the MuiDataGrid column headers).
// Usage: <TableHead sx={primaryTableHeadSx}>
// `!important` is needed to beat the theme's MuiTableCell/MuiTableSortLabel overrides,
// and the selector must out-specify the theme's `.MuiTableCell-root.MuiTableCell-head`
// grey rule (also !important) - on a tie, stylesheet insertion order decides and
// the grey header can win in one theme mode but not the other.
var primaryTableHeadSx = function (theme) { return ({
    "& .MuiTableCell-root.MuiTableCell-head": {
        backgroundColor: "".concat(theme.palette.primary.main, " !important"),
        color: theme.palette.primary.contrastText,
        fontWeight: "bold",
    },
    "& .MuiTableSortLabel-root, & .MuiTableSortLabel-root:hover, & .MuiTableSortLabel-root.Mui-active, & .MuiTableSortLabel-icon": {
        color: "".concat(theme.palette.primary.contrastText, " !important"),
    },
    "& .MuiCheckbox-root, & .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-root.MuiCheckbox-indeterminate": {
        color: theme.palette.primary.contrastText,
    },
}); };
exports.primaryTableHeadSx = primaryTableHeadSx;
//# sourceMappingURL=tableStyles.js.map